export default "__VITE_ASSET__Bp81cy5x__"